<template>
  <div>
    <el-collapse v-if="items.length" v-model="active" @change="toggle">
      <el-collapse-item name="news">
        <template #title> News </template>
        <el-carousel
          v-if="show"
          v-loading="loading"
          :interval="5000"
          arrow="never"
          indicator-position="none"
        >
          <el-carousel-item v-for="item in items" :key="item.id">
            <el-row>
              <el-col
                v-if="item.attributes.logo"
                :md="4"
                :lg="4"
                :xl="4"
                :xs="0"
                :sm="4"
              >
                <img :src="item.attributes.logo" />
              </el-col>
              <el-col :md="20" :lg="20" :xl="20" :xs="24" :sm="20">
                <div class="news-right">
                  <h3>{{ item.attributes.title }}</h3>
                  <p>{{ item.attributes.description }}</p>
                  <el-link
                    v-if="item.attributes.link"
                    :href="item.attributes.link"
                    target="_blank"
                  >
                    Learn more...
                  </el-link>
                </div>
              </el-col>
            </el-row>
          </el-carousel-item>
        </el-carousel>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script lang="ts">
import useResize from '@/hooks/useResize'

import { defineComponent, computed, ref } from 'vue'
import { useCookies } from 'vue3-cookies'
import { useNewsStore } from '@/store/modules/news'

const NEWS_KEY = 'news_closed'
export default defineComponent({
  name: 'NewsBlock',
  setup() {
    const newsStore = useNewsStore()
    const loading = ref(true)
    const { isDesktop } = useResize()
    const { cookies } = useCookies()

    newsStore.GetItems().then(() => {
      loading.value = false
    })
    const show = computed(() => {
      return !loading.value && items.value && items.value.length > 0
    })
    const active = cookies.get(NEWS_KEY) ? null : 'news'

    const items = computed(() => {
      return Object.values(newsStore.items).sort(
        (a, b) => Number(b.id) - Number(a.id)
      )
    })

    const toggle = (arg: any) => {
      if (arg.includes('news')) {
        cookies.remove(NEWS_KEY)
      } else {
        cookies.set(NEWS_KEY, true)
      }
    }
    return { isDesktop, show, active, toggle, items, loading }
  }
})
</script>

<style lang="scss" scoped>
.el-collapse {
  margin-right: 10px;
  margin-bottom: 10px;
}
.news-right {
  padding: 0 10px 10px 10px;
  h3 {
    margin: 0;
  }
}
img {
  height: 100%;
  max-height: 200px;
  padding: 10px;
  max-width: 100%;
}
.el-carousel {
  margin-bottom: 10px;
}
:deep(.el-collapse-item__header) {
  height: 35px;
  padding: 5px;
  border-radius: 4px;
}

:deep(.el-carousel__container) {
  height: auto;
  min-height: 150px;
}
</style>
